export default {
  title: 'Personal Information',
  warningTopText: 'Please note that if you have contracts with the following institutions, you must contact them directly to update your personal information:',
  phoneLabel: 'Phone number',
  emailLabel: 'E-mail',
  websiteLabel: 'Website',
  infoSeparator: ': ',
  continueButton: 'Continue',
};
